import { memo, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { useAppContext } from "../../Context/AppContext";
import { clearTokens } from "../../auth/authStorage";
import { useNavigate } from "react-router-dom";

const SessionExpiredModal = memo(function SessionExpiredModal() {
  const { sessionExpired, setSessionExpired } = useAppContext();
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    setSessionExpired(false);
  }, [setSessionExpired]);

  const handleLoginAgain = useCallback(async () => {
    try {
      clearTokens();
      setSessionExpired(false);
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  }, [navigate, setSessionExpired]);

  return (
    <Modal show={sessionExpired} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Session Expired</Modal.Title>
      </Modal.Header>
      <Modal.Body>Your session has expired. Please login again to continue.</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleLoginAgain}>
          Login Again
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

SessionExpiredModal.displayName = "SessionExpiredModal";

export default SessionExpiredModal;
